import "/acf-blocks/block-image/block-image.scss"
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

class BlockImage {
  constructor() {
    this.videoBlocks = document.querySelectorAll('.js-video')
    this.players = []
    this.events()
  }

  events = () => {
    if (!this.videoBlocks.length) return
    
    this.videoBlocks.forEach((video, index) => {
      let player = videojs(video, {
        nativeControlsForTouch: true,
        normalizeAutoplay: true,
        autoplay: false,
        fluid: true,
        inactivityTimeout: 0,
        controls: true,
        bigPlayButton: false,
        muted: true,
        controlBar: {
          children: [
            'playToggle',
            'currentTimeDisplay',
            'timeDivider',
            'durationDisplay',
            'fullscreenToggle',
            'muteToggle'
          ],
          volumePanel: false,
          progressControl: false,
          remainingTimeDisplay: false,
          pictureInPictureToggle: false,
          muteToggle: true
        }
      })
      player.addClass('vjs-matrix')
      
      // Store player reference
      this.players.push({
        player: player,
        element: video.closest('.block-image') || video.parentElement
      })
      
      // player.controlBar.hide()
      
      // player.on('play', () => {
      //   player.controlBar.show()
      // })
      
      // player.on('pause', () => {
      //   player.controlBar.hide()
      // })
      
      player.on('ended', () => {
        player.currentTime(0)
        player.pause()
        // player.controlBar.hide()
        player.hasStarted(false)
      })
    })
    
    this.setupIntersectionObserver()
  }

  setupIntersectionObserver = () => {
    if (!this.players.length) return
    
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    }
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Get player from the observed element's data attribute
        const playerIndex = parseInt(entry.target.dataset.playerIndex)
        const playerData = this.players[playerIndex]
        
        if (!playerData) return
        
        const { player } = playerData
        
        if (entry.isIntersecting) {
          // Video is in viewport - play
          if (player.readyState() >= 2) {
            // Video is loaded, play immediately
            player.play().catch(error => {
              // Handle autoplay restrictions
              console.log('Autoplay prevented:', error)
            })
          } else {
            // Wait for video to be ready
            player.ready(() => {
              player.play().catch(error => {
                // Handle autoplay restrictions
                console.log('Autoplay prevented:', error)
              })
            })
          }
        } else {
          // Video is not in viewport - pause
          if (!player.paused()) {
            player.pause()
          }
        }
      })
    }, observerOptions)
    
    // Observe each video container and store index
    this.players.forEach(({ element }, index) => {
      element.dataset.playerIndex = index
      observer.observe(element)
    })
  }
}

document.addEventListener('DOMContentLoaded', function() {
	new BlockImage()
})